import React, { useState } from 'react';

const OptimizedImage = ({ 
  src, 
  alt, 
  className = '', 
  width,
  height,
  lazy = true,
  placeholder = true 
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  // Create placeholder gradient based on alt text
  const getPlaceholderColor = (alt) => {
    if (alt.toLowerCase().includes('london')) return 'linear-gradient(135deg, #1e40af, #3b82f6)';
    if (alt.toLowerCase().includes('ai') || alt.toLowerCase().includes('tech')) return 'linear-gradient(135deg, #dc2626, #ef4444)';
    if (alt.toLowerCase().includes('business')) return 'linear-gradient(135deg, #374151, #6b7280)';
    return 'linear-gradient(135deg, #111827, #374151)';
  };

  const handleImageLoad = () => {
    setIsLoaded(true);
  };

  const handleImageError = () => {
    setHasError(true);
  };

  return (
    <div 
      className={`optimized-image-container ${className}`}
      style={{ 
        width: width || '100%', 
        height: height || 'auto',
        position: 'relative',
        overflow: 'hidden',
        borderRadius: '8px'
      }}
    >
      {/* Placeholder */}
      {(!isLoaded || hasError) && (
        <div 
          className="image-placeholder"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: getPlaceholderColor(alt),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: '14px',
            fontWeight: '500',
            textAlign: 'center',
            padding: '20px',
            zIndex: 1
          }}
        >
          {hasError ? (
            <div>
              <div style={{ fontSize: '24px', marginBottom: '8px' }}>📷</div>
              <div>Image placeholder</div>
              <div style={{ fontSize: '12px', opacity: 0.8, marginTop: '4px' }}>
                {alt}
              </div>
            </div>
          ) : (
            <div>
              <div style={{ fontSize: '24px', marginBottom: '8px' }}>⏳</div>
              <div>Loading...</div>
            </div>
          )}
        </div>
      )}

      {/* Actual Image */}
      <img
        src={src}
        alt={alt}
        loading={lazy ? 'lazy' : 'eager'}
        onLoad={handleImageLoad}
        onError={handleImageError}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          transition: 'opacity 0.3s ease',
          opacity: isLoaded && !hasError ? 1 : 0,
          position: 'relative',
          zIndex: 2
        }}
      />
    </div>
  );
};

export default OptimizedImage;